<template>
	<div>
		<div class="row1">
			<div>
				<el-button @click="onAdd" class="row-btn add" type="primary" size="small">增加</el-button>
				<el-button @click="onDel" class="row-btn del" type="primary" size="small">删除</el-button>
			</div>
		</div>
		<div class="tab-box">
			<el-table
				v-loading="loading"
				element-loading-text="加载中"
				:header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
				ref="multipleTable"
				:data="tableData"
				tooltip-effect="dark"
				style="width: 100%"
				@selection-change="handleSelectionChange"
			>
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column label="序号">
					<template slot-scope="scope">
						{{ scope.row.id }}
					</template>
				</el-table-column>
				<el-table-column prop="username" label="账号"></el-table-column>
				<!-- <el-table-column prop="address" label="密码"> </el-table-column> -->
				<el-table-column prop="name" label="姓名"></el-table-column>
				<el-table-column prop="auth_ids.text" label="所属角色"></el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						<el-switch
						@change="change(scope.row)"
						  v-model="scope.row.status == 1">
						</el-switch>
						{{ scope.row.status == 1 ? '启用' : '禁用' }}
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="添加时间"></el-table-column>
				<el-table-column label="操作" width="350" align="center">
					<template slot-scope="scope">
						<span class="btn-txt txtC" @click="handleEdit(scope.row)">修改</span>
						<span class="btn-txt del-txt" @click="handleDel(scope.row)">删除</span>
						<!-- <span class="btn-txt txtC" @click="modifyState(scope.row,1)">启动</span>
						<span class="btn-txt" @click="modifyState(scope.row,0)">禁用</span> -->
						<span class="btn-txt txtC" @click="handleReset(scope.row)">重置密码</span>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="page-box">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 15, 20, 30, 50, 100]"
					:page-size="10"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</div>
		</div>
		<!-- 添加账号弹框 -->
		<add-account :title="title" 
		:disabled="disabled"
		:obj="accountObj" 
		:arr="roleArr" 
		@addAccount="addAccount" 
		@editAccount="editAccount"
		ref="detailDialog"></add-account>
	</div>
</template>

<script scoped>
import addAccount from '../../components/dialog/addAccount.vue';
export default {
	components: {
		addAccount
	},
	data() {
		return {
			disabled:false,
			title:'新建账号',
			accountObj:'',//修改对象
			roleArr:[],//角色列表
			tableData: [],
			pageObj: {
				limit: 10,
				page: 1
			},
			total: 0, //总条数
			multipleSelection: [], //勾选的数据
			currentPage: 1, //当前页
			loading: true //是否显示加载中图标
		};
	},
	created() {
		this.getList();
	},
	methods: {
		//重置密码
		handleReset(v){
			this.$confirm('确认重置密码？', '提示').then(() => {
				this.$api.resetPwd({id:v.id}).then((res)=>{
					if(res.code == 1){
						this.$message.success(res.msg)
					}else{
						this.$message.error(res.msg)
					}
				})
			}).catch(()=>{})
		},
		// 启用/禁用
		change(data){
			let obj = {
				id:data.id,
				field:'status',
				value:data.status == 1 ? 0 : 1
			}
			this.$api.modifyState(obj).then((res)=>{
				if(res.code == 1){
					this.$message.success(data.status == 1?'已禁用':'已启用')
					this.getList()
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		// // 启用/禁用
		// modifyState(data,value){
		// 	let obj = {
		// 		id:data.id,
		// 		field:'status',
		// 		value:value
		// 	}
		// 	this.$api.modifyState(obj).then((res)=>{
		// 		if(res.code == 1){
		// 			this.$message.success(value == 1?'已启用':'已禁用')
		// 			this.getList()
		// 		}else{
		// 			this.$message.error(res.msg)
		// 		}
		// 	})
		// },
		// 修改
		editAccount(data){
			// console.log(data);
			let obj = {
				id:data.id,
				phone:data.phone,
				name:data.uname,
				auth_ids:Number(data.region) >= 0 ? data.region:data.regionid.auth_ids
			}
			// console.log(obj);
			this.$api.editAccount(obj).then((res)=>{
				if(res.code == 1){
					this.$message.success(res.msg)
					this.$refs.detailDialog.dialogVisible = false;
					this.getList()
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		// 修改账号弹框
		handleEdit(v){
			this.getRole() //获取角色列表
			this.title = '修改账号';
			this.disabled = true;
			this.$refs.detailDialog.ruleForm = {
				id:v.id,
				name:v.username,
				uname:v.name,
				phone:v.phone,
				region:v.auth_ids.text,
				regionid:v.auth_ids.value
			}
			this.$refs.detailDialog.dialogVisible = true;
		},
		// 添加账户
		addAccount(data) {
			let obj = {
				username:data.name,
				phone:data.phone,
				name:data.uname,
				password:data.pwd,
				auth_ids:data.region
			}
			this.$api.addAccount(obj).then((res)=>{
				if(res.code == 1){
					this.$message.success(res.msg)
					this.$refs.detailDialog.$refs["ruleForm"].resetFields()//清空输入的表单
					this.$refs.detailDialog.dialogVisible = false;
					this.getList()
				}else{
					this.$message.error(res.msg)
				}
			})
		},
		//删除账号
		handleDel(v){
			 this.$confirm('确认删除：'+v.username+' ？', '提示').then(() => {
				 this.$api.delAccount({id:v.id}).then((res)=>{
				 	if(res.code == 1){
				 		this.$message.success(res.msg)
				 		this.getList()
				 	}else{
				 		this.$message.error(res.msg)
				 	}
				 })
			}).catch(()=>{})
		},
		// 打开添加弹框
		onAdd() {
			for(let key in this.$refs.detailDialog.ruleForm){
				this.$refs.detailDialog.ruleForm[key] = ""
			}
			this.disabled = false;
			this.getRole() //获取角色列表
			this.$refs.detailDialog.dialogVisible = true;
		},
		//删除多项
		onDel() {
			if (!this.multipleSelection.length) return this.$message.error('请勾选要删除的选项！');
			let ids = []
			this.multipleSelection.forEach((v,k)=>{
				ids[k] = v.id
			})
			this.$confirm('确认删除？', '提示').then(() => {
				this.$api.delAccount({id:ids}).then((res)=>{
					if(res.code == 1){
						this.$message.success(res.msg)
						this.getList()
					}else{
						this.$message.error(res.msg)
					}
				})
			}).catch(()=>{})
		},
		// 获取数据列表
		getList() {
			this.loading = true;
			this.$api.userList(this.pageObj).then(res => {
				this.loading = false;
				if (res.code == 1) {
					this.total = res.count;
					this.tableData = res.data;
				}
			})
			.catch(err => {
				this.loading = false;
			});
		},
		// 获取角色
		getRole(){
			this.$api.roleList({selectFields:'id,title'}).then(res => {
				if (res.code == 1) {
					this.roleArr = res.data;
				}else{
					this.$message
				}
			})
		},
		// 多选事件
		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log(val);
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pageObj.limit = val;
			this.getList();
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.pageObj.page = val;
			this.getList();
		}
	}
};
</script>

<style lang="scss">
@import '../../assets/css/public.scss';
</style>
